module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.scrollTop > 300) ? _c('div', {
    staticClass: "top-btn",
    attrs: {
      "id": "top-btn"
    },
    on: {
      "click": _vm.scrollToTop
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e3ecfdd8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/btnGoTop.vue
// module id = 156
// module chunks = 0